import type { EControlSettingType, IControlSettingData } from '../../type';

import { getAllControlIds, updateControlSettingData } from '../utils';
import { useControlSettingStore } from '../stores/control-setting';
import { useMemo } from 'react';

interface UseControlSettingProps {
  type: EControlSettingType;
  controlData: IControlSettingData;
}

export const useControlSetting = ({ type, controlData }: UseControlSettingProps) => {
  const controlSettingUI = useControlSettingStore((state) => state.controlSettingUI);

  const { allControlIds, settings } = useMemo(() => {
    const settings = controlSettingUI[type];
    return {
      settings,
      allControlIds: getAllControlIds(settings),
    };
  }, [controlSettingUI, type]);

  const mapControlSettingData = useMemo(() => {
    return updateControlSettingData({
      settings,
      values: controlData,
      allControlIds,
    });
  }, [controlData, settings, allControlIds]);

  return mapControlSettingData;
};
